<template>
    <div>
        <v-chip :color="dataCountInfo == null? 'red': 'green'" outlined style="height:3.2vh; margin:0px 4px 0px 4px">
            <v-icon left style="font-size:2.4vh">check_circle_outline</v-icon>
            <span v-if="dataCountInfo == null">{{dataInfoName}} Not Selected </span> 
            <span v-else>{{dataInfoName}}  {{dataCountInfo}} Records</span> 
        </v-chip>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        props: ['dataCountInfo','dataInfoName'],
        data() {
            return {
            };
        },
        computed: {
            ...mapState({
               // dataCountInfo: state => state.YourDataStore.dataCountInfo,
            }),
        },
        methods: {

        }
    };
</script>
<style scoped>
    .v-chip
    {
        font-size:1.4vh
    }
</style>